var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_37206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.192 87.0962C173.192 134.646 134.646 173.192 87.0956 173.192C39.5462 173.192 1 134.646 1 87.0962C1 39.5468 39.5462 1 87.0956 1C134.646 1 173.192 39.5468 173.192 87.0962Z",
    stroke: "#95CBB2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8194 20C123.697 20 153.639 49.9418 153.639 86.8194C153.639 123.697 123.697 153.639 86.8194 153.639C49.9418 153.639 20 123.697 20 86.8194C20 49.9418 49.9418 20 86.8194 20Z",
    fill: "#95CBB2",
    stroke: "#95CBB2",
    strokeWidth: 7.49468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 91.6478L73.4869 110.135L118.622 65",
    stroke: "white",
    strokeWidth: 8.32742,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.82 26.9349C139.143 23.6119 142.075 20.6797 142.075 20.6797",
    stroke: "#95CBB2",
    strokeWidth: 7.03367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.617 49.4742C159.94 46.1509 162.872 43.2188 162.872 43.2188",
    stroke: "#95CBB2",
    strokeWidth: 7.03367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.531 32.7612C158.155 26.2756 163.999 20.5527 163.999 20.5527",
    stroke: "#95CBB2",
    strokeWidth: 7.03367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_37206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c07088d21e8b770550dac09c19f928e0.svg";
export { ForwardRef as ReactComponent };